import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function HomeOne() {
    return (
        <Container fluid className="home-explore-container mb-5" >
            <Row>
                <Col>
                    <h3 className="home-explore-title" > Installation | 24x7 Support | AMC Service </h3>
                    <p className="home-explore-text" > The Best Solutions For Developing Your BusinessWe are the best solution for the growth and development of your home, office, industry, etc. </p>
                    <a href='/images/pdf/quote.pdf' className="home-explore-link" target="_blank" > Get Quote </a>
                </Col>
            </Row>
        </Container>
    )
}
